import ComingSoon from "app/components/ComingSoon";
import {
  PostActiveIcon,
  PostIcon,
  ServiceActiveIcon,
  ServiceIcon,
  SettingActiveIcon,
  SettingIcon,
  AdviseIcon,
  AdviseActiveIcon,
  MediaActiveIcon,
  MediaIcon,
} from "app/components/Icon";
import Inventory from "app/containers/Protected/Inventory";
import InventoryForm from "app/containers/Protected/Inventory/InventoryForm";
import InventoryImport from "app/containers/Protected/Inventory/InventoryImport";
import InventoryList from "app/containers/Protected/Inventory/InventoryList";
import LeadPresenter from "app/containers/Protected/Lead/Lead.presenter";
import LeadListPage from "app/containers/Protected/Lead/LeadList/LeadList.presenter";
import MediaPresenter from "app/containers/Protected/Media/Media.presenter";
import MediaListPage from "app/containers/Protected/Media/MediaList/MediaList.presenter";
import Post from "app/containers/Protected/Post";
import PostForm from "app/containers/Protected/Post/PostForm";
import PostList from "app/containers/Protected/Post/PostList";
import { STORAGE } from "constant";
import { PAGE_ROUTE } from "constant/routes/page";
import { ERoleNameUser, IProfileAuthOutputModel } from "interfaces";
import { PageRouteType } from "models";

const profileLocal: IProfileAuthOutputModel = JSON.parse(localStorage.getItem(STORAGE.LOCAL_PROFILE) || '""');

export const pageRoutes: PageRouteType[] = [
  {
    path: PAGE_ROUTE.ADM_INVENTORY,
    component: Inventory,
    icon: [ServiceIcon, ServiceActiveIcon],
    title: "Toà nhà",
    children: [
      {
        path: PAGE_ROUTE.ADM_INVENTORY_LIST,
        component: InventoryList,
        title: "Toà nhà",
        render: true,
      },
      { path: PAGE_ROUTE.ADM_INVENTORY_CREATE, component: InventoryForm, title: "Tạo toà nhà", hideSidebar: true },
      { path: PAGE_ROUTE.ADM_INVENTORY_EDIT, component: InventoryForm, title: "Chỉnh sửa toà nhà", hideSidebar: true },
      { path: PAGE_ROUTE.ADM_INVENTORY_IMPORT, component: InventoryImport, title: "Nhập toà nhà", hideSidebar: true },
    ],
    render: true,
  },
  {
    path: PAGE_ROUTE.ADM_MEDIA,
    component: MediaPresenter,
    title: "Thư viện",
    icon: [MediaIcon, MediaActiveIcon],
    children: [
      {
        path: PAGE_ROUTE.ADM_MEDIA_LIST,
        component: MediaListPage,
        title: "Thư viện",
        render: true,
      },
    ],
    render: true,
  },
  {
    path: PAGE_ROUTE.ADM_POST,
    component: Post,
    title: "Bài viết",
    icon: [PostIcon, PostActiveIcon],
    children: [
      {
        path: PAGE_ROUTE.ADM_POST_LIST,
        component: PostList,
        title: "Bài viết",
        render: true,
      },
      { path: PAGE_ROUTE.ADM_POST_CREATE, component: PostForm, title: "Tạo bài viết", hideSidebar: true },
      { path: `${PAGE_ROUTE.ADM_POST_EDIT}`, component: PostForm, title: "Chỉnh sửa bài viết", hideSidebar: true },
    ],
    render: true,
  },
  {
    path: PAGE_ROUTE.ADM_LEAD,
    component: LeadPresenter,
    title: "Khách tiềm năng",
    icon: [AdviseIcon, AdviseActiveIcon],
    children: [
      {
        path: PAGE_ROUTE.ADM_LEAD_LIST,
        component: LeadListPage,
        title: "Khách tiềm năng",
        render: true,
      },
    ],
    render: true,
  },
  {
    path: PAGE_ROUTE.ADM_SETTING,
    component: ComingSoon,
    icon: [SettingIcon, SettingActiveIcon],
    title: "Thiết lập",
    render: true,
    // render: true
  },
];
